module.exports = __webpack_public_path__ + "img/flex5_3-menu-desktop.fc299309.png";